module.exports = __webpack_public_path__ + "img/main-lbl.ed45a679.png";